import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import { createSelector } from 'reselect';
import PropTypes from 'prop-types';
// Cloud React components
import { AsyncSelect } from 'Components';
import { NotificationManager } from 'Components/Notifications';
import _ from 'lodash';

//actions
import {
  getEntityList,
  clearRedux
} from 'Redux/actions';


const getError = (state) => state.entityPickerRedux.error;
const getData = (state) => state.entityPickerRedux.data;
const getLoading = (state) => state.entityPickerRedux.loading;
const getTotal = (state) => state.entityPickerRedux.total;

const entityReduxServer = (id) => {
  return createSelector(
    [getError, getData, getLoading, getTotal],
    (error, data, loading, total) => {
      return [error[id], data[id], loading[id], total[id]]
    }
  )
}

const ENTITY_PICKER_LIMIT = 25;
const EntityPicker = (props) => {
  const dispatch = useDispatch();
  const { intl } = props;
  const { messages } = intl;

  const {
    id,
    name,
    entity,
    onChange,
    required,
    disabled,
    hideLabel,
    value
  } = props;

  const [
    error,
    data,
    loading,
    total
  ] = useSelector(entityReduxServer(id), (prevProps, nextProps) => {
    return _.isEqual(prevProps, nextProps);
  });

  const entityPickerRedux = useSelector(state => state.entityPickerRedux);

  let placeholder = "";
  let label = "";
  if (entity === "landmarks") {
    placeholder = messages['entityPicker_landmark'];
    label = messages['entityPicker_landmark'];
  } else if (entity === "equipments") {
    placeholder = messages['entityPicker_equipments'];
    label = messages['entityPicker_equipments'];
  }

  useEffect(() => {
    onSearch("", 0);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearRedux("ENTITY_PICKER", {
        data: { ...entityPickerRedux.data, [id]: [] },
        error: { ...entityPickerRedux.error, [id]: false },
        openSearch: { ...entityPickerRedux.openSearch, [id]: "" },
        loading: { ...entityPickerRedux.loading, [id]: false },
        total: { ...entityPickerRedux.total, [id]: 0 },
      }));
    }
  }, []);
  
  useEffect(() => {
    if (error) {
      NotificationManager.error(
        messages['entityPicker_error'],
        messages['error'],
        3000,
        null,
        null,
        'warning',
      );
    }
  }, [error]);

  const onSearch = useCallback((searchText, page) => {
    dispatch(getEntityList({
      id: id,
      entity: entity,
      openSearch: searchText,
      offset: (page * ENTITY_PICKER_LIMIT),
      limit: ENTITY_PICKER_LIMIT
    }));
  });


  return (
    <AsyncSelect
      id={id}
      name={name}
      loading={loading}
      label={hideLabel ? null : label}
      placeholder={placeholder}
      data={data || []}
      value={value}
      onSearch={onSearch}
      onChange={(value) => {
        if (onChange) onChange(value);
      }}
      idKey="id"
      nameKey="name"
      hasMore={data?.length < (total || 0)}
      required={required}
      disabled={disabled}
      total={total || 0}
    />
  )
}

export default injectIntl(EntityPicker);

EntityPicker.propTypes = {
  entity: PropTypes.string.isRequired,
  entity: PropTypes.oneOf(['landmarks', 'equipments'])
};